module.exports = __webpack_public_path__ + "static/media/bowen-51.9b145528.jpg";